import { CheckCircle2, Phone } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import BookingEmbed from "../components/BookingEmbed";
import { BUSINESS } from "../data/site";
import { track } from "../lib/api";

const ASSURANCES = [
  "No surprise fees. No games. Straightforward pricing.",
  "No maximum rental period — keep it as long as the job requires.",
  "Same-Day Swaps Available for existing rental customers.",
  "Nathaniel or Kay personally handles every booking.",
];

export default function RequestDumpster() {
  return (
    <>
      <SEO
        title="Request a Dumpster"
        description="Request a roll-off dumpster from Yavapai Waste Solutions. 20–40 yard sizes across Yavapai County. Straightforward pricing, no hidden fees."
        path="/request-a-dumpster"
      />
      <section className="py-12 sm:py-16 bg-slate-50 min-h-[70vh]" data-testid="request-page">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-5 gap-10 items-start">
          <div className="lg:col-span-2 lg:sticky lg:top-24">
            <Reveal>
              <h1 className="font-heading font-extrabold tracking-tight text-4xl text-slate-900 leading-[1.05]">Request a Dumpster</h1>
              <p className="mt-4 text-slate-600 leading-relaxed">
                Book online in minutes through our secure booking system — or call us and we'll set it up together during business hours (Mon–Fri, 8 AM–5 PM).
              </p>
              <ul className="mt-6 space-y-3">
                {ASSURANCES.map((a) => (
                  <li key={a} className="flex items-start gap-3 text-sm text-slate-700">
                    <CheckCircle2 className="h-5 w-5 text-sky-600 shrink-0" />
                    {a}
                  </li>
                ))}
              </ul>
              <a
                href={BUSINESS.phoneHref}
                onClick={() => track("click_to_call", { location: "request_page" })}
                className="mt-7 inline-flex items-center gap-2 font-heading font-semibold text-sky-700 hover:text-sky-800"
                data-testid="request-page-call"
              >
                <Phone className="h-4 w-4" /> Prefer to talk? {BUSINESS.phone}
              </a>
            </Reveal>
          </div>
          <div className="lg:col-span-3">
            <Reveal delay={0.1}>
              <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                <BookingEmbed heightClass="h-[80vh] min-h-[640px]" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
